<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card card-body">
        <h2 class="text-center">
            الربط مع <img src="/assets/images/hudury.png" width="32" alt=""> حضوري
        </h2>
        <div class="alert alert-success g">
            بعد الربط مع حضوري سيتم جلب التقارير تلقائياً من نظام حضوري الى نظام التحضير الذكي والتعامل معها كأنها تقارير من التحضير الذكي واعتماد اعدادات الإرسال وغيرها...
        </div>
        <template v-if="teachers.length == 0">
            <hr>
            <div class="alert alert-danger g text-center" id="ccdcxczxdd_43">
                <h5>
                    <i class="fa fa-warning"></i>
                    لم يتم استيراد بيانات المعلمين للنظام,<br> يجب استيراد بيانات المعلمين لتتمكن من جلب التقارير من حضوري.
                </h5>
            </div>
        </template>
        <hr>
        <h5>
            <div class="form-check">
              <h5 class="form-check-label">
                <input type="checkbox" @change="save()" class="form-check-input" id="hix" v-model="hudury.enabled">
                <span @click="hix()" style="position: relative; top: 3px">تفعيل
                الربط مع حضوري</span>
              </h5>
            </div>
        </h5>
        <template v-if="hudury.enabled">
            <hr>
            <div class="col-12 table-responsive" style="min-height: auto;">
                <table class="table table-hover table-bordered">
                    <tbody>
                        <tr>
                            <td>
                                رمز الربط
                            </td>
                            <td>
                                {{ hudury.otp }}
                                <a href="javascript:;" class="btn btn-sm border" style="padding: 5px; background: #eee"
                                @click="copyOTP()"
                                >
                                    <i class="fa fa-copy"></i>  
                                    نسخ
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                حالة الربط
                            </td>
                            <td>
                                <span v-if="hudury.status == 0" class="btn btn-sm btn-warning" style="padding: 5px">
                                    لم يتم الربط
                                </span>
                                <span v-if="hudury.status == 1 && hudury.online" class="btn btn-sm btn-success" style="padding: 5px">
                                    <i class="fa fa-check"></i>
                                    متصل الآن — يتم الإرسال كل دقيقتين
                                </span>
                                <span v-if="hudury.status == 1 && !hudury.online" class="btn btn-sm btn-warning" style="padding: 5px">
                                    صفحة حضوري مغلقة — لا يتم الإرسال حالياً
                                </span>
                                <span v-if="hudury.status == 2" class="btn btn-sm btn-danger" style="padding: 5px">
                                    انتهت جلسة حضوري، سجّل الدخول في حضوري
                                </span>
                            </td>
                        </tr>
                        <tr v-if="hudury.pending_tasks > 0">
                            <td>
                                طلبات بانتظار التنفيذ
                            </td>
                            <td>
                                {{ hudury.pending_tasks }}
                                <small class="text-muted">تُنفَّذ تلقائياً عند فتح صفحة حضوري</small>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                عدد الموظفين
                            </td>
                            <td>
                                {{ hudury.users.length }}
                                <button class="btn btn-sm btn-primary" v-b-modal.viewusers style="padding: 3px">
                                    <i class="fa fa-eye"></i> عرض 
                                </button>
                                <button class="btn btn-sm btn-secondary" title="الاستعلام عن المستخدمين من حضوري" @click="getUsers()" style="padding: 3px; margin-right: 3px">
                                    <i class="fa fa-refresh"></i> 
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                آخر إرسال من حضوري
                            </td>
                            <td>
                                {{ hudury.last_active }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
    <div class="card card-body">
        <div class="row">
            <div class="col-12 col-lg-6 g">
                <a href="https://chromewebstore.google.com/detail/%D9%85%D8%B3%D8%A7%D8%B9%D8%AF-%D8%AD%D8%B6%D9%88%D8%B1%D9%8A/fcciehnilalgimppgikbmlmpklaeckmj" class="btn btn-primary btn-block" target="_blank">
                    <i class="fa fa-download"></i>
                    لتثبيت الأداة اضغط هنا
                </a>
            </div>
            <div class="col-12 col-lg-6 g">
                <a href="https://hather-ui.moe.gov.sa/" class="btn btn-success btn-block" target="_blank">
                    <i class="fa fa-external-link"></i>
                    للذهاب لموقع حضوري اضغط هنا
                </a>
            </div>
            <div class="col-12 g">
                <div class="alert alert-danger g">
                   <span class="text-dark"> ملاحظة: أوقف نظام حضوري الاستعلام من خارج موقعه، لذلك أصبحت أداة مساعد حضوري ترسل التقرير إلى التحضير الذكي من داخل صفحة حضوري فور فتحها ثم كل دقيقتين.
                    <br>يجب إبقاء صفحة حضوري مفتوحة (مع الأداة) طوال الدوام، وعند إغلاقها يتوقف إرسال التقرير.
                    <br>طريقة الربط: افتح حضوري ← «ربط بالتحضير الذكي» من لوحة الأداة ← أدخل رمز الربط ← إضافة.</span>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="viewusers" title="استعراض" hide-footer size="lg">
        <div class="col-12 table-responsive">
            <div class="col-12 text-center g" v-if="selected.length">
                <button class="btn btn-lg btn-success" @click="addNow()">
                    <i class="fa fa-check"></i>
                    إضافة المحددين للتحضير الذكي
                </button>
            </div>
            <table class="table table-sm table-bordered">
                <thead>
                    <th>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" @click="asl()">
                            اختيار الكل
                          </label>
                        </div>
                    </th>
                    <th>
                        الاسم
                    </th>
                    <th>
                        الجوال
                    </th>
                    <th>
                        الهوية
                    </th>
                </thead>
                <tbody>
                    <tr v-for="u in hudury.users" :key="u.number" :class="selected.includes(u.number) ? 'bg-light-secondary' : ''">
                        <td>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" v-model="selected" :value="u.number">
                                اختيار
                              </label>
                            </div>
                        </td>
                        <td>
                            {{ u.name }}
                        </td>
                        <td>
                            {{ u.phone }}
                        </td>
                        <td>
                            {{ u.number }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
  </div>
</template>

<script>
const axios = require("axios");
import Ripple from "vue-ripple-directive";
import {
  VBModal
} from "bootstrap-vue";
export default {
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
    data(){
        return {
            selected: [],
            user: JSON.parse(localStorage.getItem('user')),
            teachers: [],
            hudury: {
                enabled: false,
                status: 0,
                users: [],
                last_active: "--"
            },
            inter: null
        }
    },
    beforeDestroy(){
        if(this.inter){
            clearInterval(this.inter)
        }
    },
    created(){
        var g = this;
        g.gett()
        var tx = false;
        setInterval(() => {
            if(tx == false){
                tx = true;
                $("#ccdcxczxdd_43").animate({ 'zoom': 1 }, 400);
            }else{
                tx = false;
                $("#ccdcxczxdd_43").animate({ 'zoom': 1.1 }, 400);
            }
        }, 500);
        g.inter = setInterval(() => {
            g.gett()
        }, 3000);
        var _g = this, g = this;
    axios
      .post(api + "/user/teachers/list", {
        jwt: _g.user.jwt,
      })
      .then(function (r) {
        if (r.data.status == 200) {
          _g.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ JWT",
              icon: "WarningIcon",
              variant: "danger",
            },
          });
        } else {
          _g.teachers = r.data.response;
          _g.loading = false;
        }
      })
      .catch(function () {
        _g.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ",
            icon: "WarningIcon",
            variant: "danger",
          },
        });
      });
    },
    methods: {
        addNow(){
            var g = this;
            alert('جاري التحميل...')
            $.post(api + '/user/teachers/hudury/add-users', {
                jwt: g.user.jwt,
                users: JSON.stringify(g.hudury.users),
                selected: JSON.stringify(g.selected)
            }).then(function(r){
                if(r.status == 100){
                    alert("تم اضافة المستخدمين بنجاح، سوف تظهر تقاريرهم خلال دقائق.", 100)
                    g.$router.push("/_teachers/list")
                }else{
                    alert(r.response, 200)
                }
            })
        },
        asl(){
            var g =this;
            if(g.selected.length){
                g.selected = []
            }else{
                g.selected = g.hudury.users.map(function(x){return x.number})
            }
        },
        gett(){
            var g = this;
            $.post(api + '/user/teachers/hudury/settings', {
                jwt: g.user.jwt
            }).then(function(r){
                g.hudury = r.response
            })
        },
        hix(){
            $("#hix").click()
        },
        getUsers(){
            var g = this;
            $.post(api + '/user/teachers/hudury/get-users', {
                jwt: g.user.jwt
            }).then(function(r){
                if(r.status == 100){
                    alert("تم ارسال الطلب بنجاح، سيتم تحديث القائمة خلال دقيقتين طالما صفحة حضوري مفتوحة.", 100)
                }else{
                    alert(r.response, 200)
                }
            })
        },
        copyOTP(){
            navigator.clipboard.writeText(this.hudury.otp);
            alert("تم النسخ بنجاح", 100)
        },
        save(){
            var g = this;
            $.post(api + '/user/teachers/hudury/save', {
                jwt: g.user.jwt,
                enabled: g.hudury.enabled
            }).then(function(r){
            })
        }
        
    }
}
</script>

<style>

</style>